import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import authSlice from "./AuthSlice";
import sellerSlice from "./seller/SellerSlice";
import sellerProductReducer from "./seller/sellerProductSlice";
import productSlice from "./customer/productSlice";
import cartSlice from "./customer/cartSlice";
import orderSlice from "./customer/orderSlice";
import wishlistSlice from "./customer/wishlistSlice";
import homeSlice from "./customer/customerSlice";
import addressReducer from "./customer/addressSlice";
import categoryReducer from "./customer/categorySlice";

import sellerOrderSlice from "./seller/sellerOrderSlice";
import transactionSlice from "./seller/transactionSlice";

import adminReducer from "./admin/adminSlice";
import dealSlice from "./admin/DealSlice";
import bannerReducer from "./admin/adminBannerSlice"; 
import adminProductReducer from './admin/adminProductSlice';
import reviewReducer from "./customer/reviewSlice";

const rootReduer = combineReducers({
  seller: sellerSlice,
  sellerProduct: sellerProductReducer,
  product: productSlice,
  auth: authSlice,
  cart: cartSlice,
  order: orderSlice,
  wishlist: wishlistSlice,
  customer: homeSlice,
  address: addressReducer,
  category: categoryReducer,

  sellerOrder: sellerOrderSlice,
  transactions: transactionSlice,
  review: reviewReducer,

  admin: adminReducer,
  deal: dealSlice,
  homeBanner: bannerReducer, 
  adminProduct: adminProductReducer,
});

const store = configureStore({
  reducer: rootReduer,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof rootReduer>;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;